export const mention = {
  user: {
    backgroundColor: 'mention.user',
  },
};
